import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import UserService from '@/services/UserService';
import axios from 'axios';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required } from '@vuelidate/validators';
import { bus } from '@/eventBus';
export default {
  props: {
    show: Boolean
  },
  setup() {
    return useSpinValidate();
  },
  data: () => {
    return {
      user: {
        username: null,
        password: null
      },
      showModal: false,
      loading: false,
      message: ''
    };
  },
  mixins: [validationMixin],
  validations: {
    user: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    close: function () {
      this.user = {
        username: null,
        password: null
      };
      this.message = '';
      this.loading = false;
      this.$emit('close');
    },
    login: async function () {
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return;
      }
      this.user.username = this.user.username.trim();
      this.user.password = this.user.password.trim();
      const data = {
        username: this.user.username,
        password: this.user.password
      };
      if (this.$route.query.wlmask && (this.$route.query.wlmask === true || this.$route.query.wlmask === 'true')) {
        if (this.$route.query.user_id && this.$route.query.userrole_id && this.$route.query.role_id) {
          data.wlmasquerade = {
            user_id: this.$route.query.user_id,
            userrole_id: this.$route.query.userrole_id,
            role_id: this.$route.query.role_id
          };
        }
      }
      UserService.login(data).then(response => {
        if (response.data.success) {
          axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.key;
          UserService.refresh().then(refresh => {
            UserService.setStorage(refresh.data);

            // vue-router 4/5 dropped router.history._startLocation; use the
            // current location's full path as the "where the user came in"
            // hint. Strip query string before testing exclusions.
            let routeTo = this.$route?.fullPath || this.$route?.path || '/';
            let cleanRoute = routeTo;
            const paramsIdx = cleanRoute.indexOf('?');
            if (paramsIdx !== -1) {
              cleanRoute = cleanRoute.substring(0, paramsIdx);
            }
            const excludedRoutes = ['/forgot/', '/', '/inactive'];
            const exclude = excludedRoutes.includes(cleanRoute) || excludedRoutes.includes(cleanRoute + '/') || cleanRoute.startsWith('/subscribe');
            if (cleanRoute === '' || exclude || typeof cleanRoute === 'undefined') {
              routeTo = '/video/channel';
            }
            this.$emit('close');
            bus.$emit('loggedIn');
            this.$router.push(routeTo).then(() => {
              this.$notify({
                group: 'notices',
                title: 'Login Successful',
                text: 'You are now logged in.',
                type: 'info'
              });
            });
          });
        } else {
          this.message = response.data.message;
          this.loading = false;
        }
      }).catch(error => {
        this.$aim.error(error.response);
        this.loading = false;
      });
    }
  },
  watch: {
    show: function (n) {
      this.showModal = n;
    }
  }
};